export class WarehouseWorkplaceSearchItem {

    serialNumber: string;
    warehouseArea: string;
    warehouse: string;
    cell: string;
}